import React, { useEffect, useState, useRef } from "react";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {
  Button,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Tooltip,
  Grid,
  TextField,
  Autocomplete,
} from "@mui/material";
import Style from "./../superAdmin/lists.module.css";
import AxiosInstance from "../apis/AxiosInstance";
import { toast } from "react-toastify";
import moment from "moment";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { Link, useNavigate } from "react-router-dom";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#eee",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#06113C",
    color: "#fff",
    padding: "8px",
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "7px",
  },
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  boxShadow: "none",
  color: theme.palette.text.secondary,
}));

const preventMinus = (e) => {
  if (isNaN(e.key)) {
    e.preventDefault();
  }
};
const preventPasteNegative = (e) => {
  const clipboardData = e.clipboardData || window.clipboardData;
  const pastedData = parseFloat(clipboardData.getData("text"));
  if (pastedData < 0) {
    e.preventDefault();
  }
};

export default function NoStatusRecordList() {
  const [isSearchDisabled, setIsSearchDisabled] = useState(false);
  let [userList, setUserList] = useState([]);
  let [searchFilter, setSearchFilter] = useState("");

  const [page, setPage] = useState(1);
  const [totalLength, setTotalLength] = useState(0);

  const [unitNameOption, setUnitNameOption] = useState([]);
  const [unitNameData, setUnitNameData] = useState(null);
  const [searchUnitName, setSearchUnitName] = useState("");

  const [roleOption, setRoleOption] = useState([]);
  const [roleData, setRoleData] = useState(null);
  const [searchRoleName, setSearcRoleName] = useState("");

  const [searchDisable, setSearchDisable] = useState(false);

  const [defaultState, setDefaultState] = useState({
    userList: [],
    totalLength: 0,
  });
  const [load, setLoad] = useState(false);
  const [currentAudio, setCurrentAudio] = useState(null);

  useEffect(() => {
    let fetchData = async () => {
      if (searchUnitName !== "") {
        let stateData_x = await AxiosInstance.get(
          `/unit?search_keyword=${searchUnitName}&limit=10`
        );

        let finalStateData_X = stateData_x.data.data;
        setUnitNameOption(finalStateData_X);
      } else {
        let stateData_x = await AxiosInstance.get(`/unit?limit=10`);
        let finalStateData_X = stateData_x.data.data;
        setUnitNameOption(finalStateData_X);
      }
    };

    fetchData();
  }, [searchUnitName]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       let response;
  //       if (searchRoleName !== "") {
  //         response = await AxiosInstance.get(
  //           `/user_mini?role_ids=1&role_ids=5&search_keyword=${searchRoleName}&limit=10`
  //         );
  //       } else {
  //         response = await AxiosInstance.get(
  //           `/user_mini?role_ids=1&role_ids=5&limit=10`
  //         );
  //       }
  //       const finalStateData_X = response.data.data || [];
  //       setRoleOption(finalStateData_X);
  //     } catch (error) {
  //       console.error("Error fetching data: ", error);
  //       setRoleOption([]);
  //     }
  //   };

  //   fetchData();
  // }, [searchRoleName]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const roleIds = "1,5";
        let response;
        if (searchRoleName !== "") {
          response = await AxiosInstance.get(
            `/user_mini?role_ids=${roleIds}&search_keyword=${searchRoleName}&limit=10`
          );
        } else {
          response = await AxiosInstance.get(
            `/user_mini?role_ids=${roleIds}&limit=10`
          );
        }
        const finalStateData_X = response.data.data || [];
        setRoleOption(finalStateData_X);
      } catch (error) {
        console.error("Error fetching data: ", error);
        setRoleOption([]);
      }
    };
    fetchData();
  }, [searchRoleName]);

  useEffect(() => {
    let fetchData = async () => {
      let endpoint = `/get_no_status_record?page=${page}`;
      setLoad(true);
      try {
        let data = await AxiosInstance.get(endpoint);
        let finalData = data.data.data;
        setUserList(finalData);
        setTotalLength(data.data.filtered_count);
        setDefaultState({
          userList: finalData,
          totalLength: data.data.filtered_count,
        });
        if (searchFilter) setPage(1);
        setLoad(false);
      } catch (error) {
        console.log(error);
        setLoad(false);
      }
    };
    fetchData();
  }, [page, searchFilter]);

  const handleChangePage = async (event, newPage) => {
    let endpoint = `/get_no_status_record?page=${newPage}`;
    setLoad(true);
    if (searchFilter) {
      endpoint += `&number=${searchFilter}`;
    }
    if (roleData !== null) {
      endpoint += `&author_id=${roleData.id}`;
    }
    if (unitNameData !== null) {
      endpoint += `&unit_id=${unitNameData.ID}`;
    }
    try {
      const { data } = await AxiosInstance.get(endpoint);
      let finalData = data.data;
      setUserList(finalData);
      setTotalLength(data.filtered_count);
      setPage(newPage);
      setLoad(false);
    } catch (error) {
      toast.error("something went wrong");
      setLoad(false);
    }
  };

  const handleSearch = async () => {
    let endpoint = `/get_no_status_record?page=${1}`;
    setIsSearchDisabled(true);
    try {
      if (!searchFilter && !unitNameData && !roleData) {
        toast.warning("Select at least one data to filter.");
        return;
      }

      if (searchFilter) {
        endpoint += `&number=${searchFilter}`;
      }
      if (roleData !== null) {
        endpoint += `&author_id=${roleData.id}`;
      }
      if (unitNameData !== null) {
        endpoint += `&unit_id=${unitNameData.ID}`;
      }
      const { data } = await AxiosInstance.get(endpoint);

      let finalData = data.data;
      setUserList(finalData);
      setTotalLength(data.filtered_count);
      setPage(1);
      setSearchDisable(true);
      toast.success("Data filtered successfully.");
    } catch (error) {
      toast.error("Something went wrong");
      setSearchDisable(false);
    }
  };

  let handleClearFilterData = async () => {
    setSearchFilter("");
    setUnitNameData(null);
    setRoleData(null);
    setIsSearchDisabled(false);
    let endpoint = `/get_no_status_record?page=${page}`;

    try {
      let data = await AxiosInstance.get(endpoint);
      let finalData = data.data.data;
      setUserList(finalData);
      setTotalLength(data.data.filtered_count);
      setDefaultState({
        userList: finalData,
        totalLength: data.data.filtered_count,
      });
      if (searchFilter) setPage(1);
      setSearchDisable(false);
    } catch (error) {
      console.log(error);
    }
    let stateData_x = await AxiosInstance.get(`/unit?limit=10`);
    let finalStateData_X = stateData_x.data.data;
    setUnitNameOption(finalStateData_X);

    const roleIds = "1,5";
    let response;
    response = await AxiosInstance.get(
      `/user_mini?role_ids=${roleIds}&limit=10`
    );
    const finalStateData_X1 = response.data.data || [];
    setRoleOption(finalStateData_X1);
  };

  const totalPages = Math.ceil(totalLength / 10);

  const calculateSlNo = (index) => {
    return (page - 1) * 10 + index + 1;
  };

  const toIsoFormat = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString();
  };

  const handlePlayAudio = (audioElement) => {
    if (currentAudio && currentAudio !== audioElement) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
    }
    setCurrentAudio(audioElement);
  };

  const [filterVisible, setFilterVisible] = useState(true);

  // Function to toggle the visibility of the filter
  const toggleFilterVisibility = () => {
    setFilterVisible(!filterVisible);
  };

  return (
    <section
      id={Style.batchListBlock}
      style={{ marginTop: "4.5%", width: "100%" }}
    >
      <h1 className={Style.listHeader}>
        No Status Record List
        <span
          style={{
            color: "#06113C",
            fontSize: "20px",
            marginLeft: "25%",
            fontWeight: "bold",
          }}
        >
          Total Count: {totalLength}
        </span>
        <span
          onClick={toggleFilterVisibility}
          style={{
            color: "#06113C",
            marginLeft: "25%",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          <Tooltip title="Filter" arrow>
            {filterVisible ? (
              <>
                <Button
                  onClick={toggleFilterVisibility}
                  variant="contained"
                  size="small"
                  style={{
                    backgroundColor: "#B43F3F",
                    color: "#fff",
                    alignItems: "center",
                    fontSize: "13px",
                    padding: "3px",
                  }}
                >
                  Close Filter
                  <ArrowDropUpIcon style={{ fontSize: "20px" }} />
                </Button>
              </>
            ) : (
              <>
                <Button
                  style={{
                    backgroundColor: "#06113C",
                    color: "#fff",
                    fontSize: "13px",
                    alignItems: "center",
                    padding: "3px",
                  }}
                  size="small"
                >
                  Open Filter <ArrowDropDownIcon style={{ fontSize: "20px" }} />
                </Button>
              </>
            )}
          </Tooltip>
        </span>
      </h1>

      <Paper
        style={{
          width: "100%",
          margin: "0 auto",
          border: "1px solid #111",
          marginTop: filterVisible ? "-1%" : "-1%",
        }}
      >
        {filterVisible && (
          <Grid container gap={1} style={{ marginTop: "1%" }}>
            <Grid md={1.3} style={{ paddingLeft: "5px" }}>
              <TextField
                placeholder="Search By Number"
                label="Search By Number"
                size="small"
                fullWidth
                value={searchFilter}
                name="searchFilter"
                onKeyPress={preventMinus}
                onPaste={preventPasteNegative}
                inputProps={{ minLength: 10, maxLength: 10 }}
                onChange={(e) => {
                  setSearchFilter(e.target.value);
                  setIsSearchDisabled(false);
                }}
                //  disabled={searchDisable}
              />
            </Grid>

            <Grid md={2.0} onChange={(e) => setSearchUnitName(e.target.value)}>
              <Autocomplete
                options={unitNameOption}
                //  disabled={searchDisable}
                value={unitNameData}
                size="small"
                name="unitNameOption"
                onChange={(event, newData_xy) => {
                  setUnitNameData(newData_xy);
                  setIsSearchDisabled(false);
                }}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Unit Name"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid md={2.0} onChange={(e) => setSearcRoleName(e.target.value)}>
              <Autocomplete
                options={roleOption}
                //  disabled={searchDisable}
                value={roleData}
                size="small"
                name="roleOption"
                onChange={(event, newData_xy) => {
                  setRoleData(newData_xy);
                  setIsSearchDisabled(false);
                }}
                getOptionLabel={(option) => option.full_name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Author Name"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid md={0.5}>
              <Button
                onClick={handleSearch}
                variant="contained"
                size="small"
                fullWidth
                // disabled={isSearchDisabled}
                // style={{
                //   backgroundColor: isSearchDisabled ? "gray" : "#003285",
                //   color: "#fff",
                // }}
                style={{
                  backgroundColor: "#003285",
                  color: "#fff",
                }}
                // disabled={searchDisable}
              >
                Search
              </Button>
            </Grid>
            <Grid md={0.5}>
              <Button
                onClick={handleClearFilterData}
                variant="contained"
                color="warning"
                fullWidth
                size="small"
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        )}

        <TableContainer
          component={Paper}
          style={{
            maxHeight: window.innerWidth > 1800 ? 680 : 480,
            marginTop: "0.5%",
          }}
        >
          <Table
            sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
            aria-label="simple table"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                <StyledTableCell
                  align="center"
                  style={{ width: "90px", fontSize: "16px" }}
                >
                  Sl No
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{ width: "200px", fontSize: "16px" }}
                >
                  Mobile Number
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{ width: "200px", fontSize: "16px" }}
                >
                  Author
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{ width: "200px", fontSize: "16px" }}
                >
                  Call Date
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{ width: "200px", fontSize: "16px" }}
                >
                  Call type
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{ width: "300px", fontSize: "16px" }}
                >
                  Audio
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{ width: "200px", fontSize: "16px" }}
                >
                  Add Status
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {load ? (
                <StyledTableRow>
                  <StyledTableCell colSpan={6} align="center">
                    Loading...
                  </StyledTableCell>
                </StyledTableRow>
              ) : userList && userList.length > 0 ? (
                userList.map((val, ind) => {
                  return (
                    <StyledTableRow key={ind + 1}>
                      <StyledTableCell
                        component="th"
                        scope="row"
                        align="center"
                      >
                        {calculateSlNo(ind)}
                      </StyledTableCell>
                      <StyledTableCell
                        component="th"
                        scope="row"
                        align="center"
                      >
                        {val.number === null || val.number === "" ? (
                          "N/A"
                        ) : (
                          <a
                            href={`tel:${val.number}`}
                            style={{
                              color: "#125B9A",
                              fontWeight: "bold",
                              // textDecoration: "none",
                            }}
                          >
                            {val.number}
                          </a>
                        )}
                      </StyledTableCell>

                      <StyledTableCell
                        component="th"
                        scope="row"
                        align="center"
                      >
                        {val.author
                          ? val.author.name
                            ? val.author.name
                            : "NA"
                          : "NA"}
                      </StyledTableCell>
                      <StyledTableCell
                        component="th"
                        scope="row"
                        align="center"
                      >
                        {val.call_date === null || val.call_date === ""
                          ? "NA"
                          : moment
                              .utc(toIsoFormat(val.call_date))
                              .local()
                              .format("DD-MM-yyyy hh:mm A")}
                      </StyledTableCell>

                      <StyledTableCell
                        component="th"
                        scope="row"
                        align="center"
                      >
                        {val.call_type
                          ? val.call_type.call_type
                            ? val.call_type.call_type
                            : "NA"
                          : "NA"}
                      </StyledTableCell>
                      <StyledTableCell
                        component="th"
                        scope="row"
                        align="center"
                      >
                        {val.audio ? (
                          <audio
                            src={`https://incubation.pentagonspace.in/api/v1/get_audio?name=${val.audio}`}
                            controls
                            controlsList="nodownload"
                            onPlay={(e) => handlePlayAudio(e.target)}
                          />
                        ) : (
                          "NA"
                        )}
                      </StyledTableCell>
                      <StyledTableCell
                        component="th"
                        scope="row"
                        align="center"
                      >
                        <Link to="/add_callstatus_record" state={val}>
                          <Tooltip title="Add the Status">
                            <Button
                              sx={{
                                background: "#114232",
                                color: "#fff",
                                borderColor: "none",
                                "&:hover": {
                                  background: "#114232",
                                  color: "#fff",
                                },
                              }}
                            >
                              Add
                            </Button>
                          </Tooltip>
                        </Link>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })
              ) : (
                <StyledTableRow>
                  <StyledTableCell colSpan={6}>
                    <h1 style={{ color: "red", textAlign: "center" }}>
                      No Data Found
                    </h1>
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Pagination
          style={{
            maxWidth: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0.5% auto",
          }}
          count={totalPages}
          sx={{ button: { color: "#1976D2", fontWeight: "bold" } }}
          page={page}
          onChange={handleChangePage}
        />
      </Paper>
    </section>
  );
}
